import React, { useRef } from "react";
//COMPONENTS
import Modal from "react-bootstrap/Modal";
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../../ui/inputs/Input";
//UI

export default function Companias({ setTabla, setShow, show }) {
  //REFS 1
  const codigoRef = useRef();
  const numeroInscipcionRef = useRef();
  //TODO FALTA TIPO DE COMPANIA
  const razonSocialRef = useRef();
  const denominacionRef = useRef();
  const direccionRef = useRef();
  const estadoRef = useRef();
  const municipioRef = useRef();
  const ciudadRef = useRef();
  const rifRef = useRef();
  const telefonoRef = useRef();
  const emailRef = useRef();
  const emailSecundarioRef = useRef();
  //ENCARGADO REFS
  const cedulaEncargadoRef = useRef();
  const nacionalidadEncargadoRef = useRef();
  const fechaNacEncargadoRef = useRef();
  const nombresEncargadoRef = useRef();
  const apellidosEncargadoRef = useRef();
  const direccionEncargadoRef = useRef();
  const emailEncargadoRef = useRef();
  const telefonoEncargadoRef = useRef();
  const celularEncargadoRef = useRef();
  const sexoEcargadoRef = useRef();
  // REFS 2
  const actividadPrincipalRef = useRef();
  const fechaInscripcionRef = useRef();
  const retencionISLRRef = useRef();
  const clasificacionISLRRef = useRef();
  const capitalPagadoRef = useRef();
  const capitalSuscritoRef = useRef();
  const tipoContribuyenteRef = useRef();
  const estatusRef = useRef();
  const exoneradoRef = useRef();
  const fechaRegistroRef = useRef();
  const oficinaRegistroRef = useRef();
  const protocoloRef = useRef();
  const numeroProtocoloRef = useRef();
  const folioRef = useRef();
  const numeroRegistroRef = useRef();
  //COPIAS DE RECAUDOS REFS
  const registroMercantilRef = useRef();
  const balanceGeneralRef = useRef();
  const servicioNacionalRef = useRef();
  const cedulaRepresentanteRef = useRef();
  const constanciaSucnacoopRef = useRef();
  const planillaISLRRef = useRef();
  const rifActualizadoRef = useRef();
  const solvenciaIVSSRef = useRef();
  const solvenciaINCESRef = useRef();
  const solvenciaLaboralRef = useRef();
  const solvenciaMunicipalRef = useRef();
  const ultimaActualizacionRef = useRef();
  const licenciaRef = useRef();
  const codigoAcitvidadRef = useRef();

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Registro de Contratistas</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <nav className="col-12 m-0 mb-2 p-0">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-datosProveedor-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-datosProveedor"
              type="button"
              role="tab"
              aria-controls="nav-datosProveedor"
              aria-selected="true"
            >
              Datos del Proveedor
            </button>
            <button
              className="nav-link"
              id="nav-otrosDatos-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-otrosDatos"
              type="button"
              role="tab"
              aria-controls="nav-otrosDatos"
              aria-selected="false"
            >
              Otros Datos
            </button>
          </div>
        </nav>
        <div
          className="tab-content col-12 m-0 p-0"
          id="nav-tabContent"
          style={{ minHeight: "500px" }}
        >
          <div
            className="tab-pane fade show active"
            id="nav-datosProveedor"
            role="tabpanel"
            aria-labelledby="nav-datosProveedor-tab"
            tabindex="0"
          >
            <article className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 p-0">
                <Input label="Codigo:" ref={codigoRef} />
              </div>
              <div className="col-4 m-0 p-0pl-2">
                <Input
                  label="Numero de Inscripción:"
                  ref={numeroInscipcionRef}
                />
              </div>
              <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded d-flex gap-2 justify-content-between">
                <legend className="float-none w-auto m-0">Tipo</legend>
                <div className="col-auto m-0 p-0">
                  <Radio label="Bienes y Servicios" name="tipo" id="tipo1" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label="Contratistas de Obras" name="tipo" id="tipo2" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label="Fondo Terceros" name="tipo" id="tipo3" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label="Organismos" name="tipo" id="tipo4" />
                </div>
                <div className="col-auto m-0 p-0">
                  <Radio label="Beneficiarios" name="tipo" id="tipo5" />
                </div>
              </fieldset>
              <div className="col-4 m-0 mb-2 p-0">
                <Input label="Razon Social:" ref={razonSocialRef} />
              </div>
              <div className="col-8 m-0 mb-2 p-0 pl-2">
                <Input label="Denominación Comercial:" ref={denominacionRef} />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea
                  label="Dirección:"
                  style={{ height: 70 }}
                  ref={direccionRef}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Select label="Estado:" ref={estadoRef} />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select label="Municipio:" ref={municipioRef} />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select label="Ciudad:" ref={ciudadRef} />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Input label="RIF:" ref={rifRef} />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input label="Teléfono:" ref={telefonoRef} />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input label="E-mail:" ref={emailRef} />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input label="E-mail Secundario:" ref={emailSecundarioRef} />
              </div>
              <fieldset className="col-12 m-0 mb-2 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">Encargado</legend>
                <div className="col-4 m-0 mb-2 p-0 d-flex">
                  <Select label="Cedula:" ref={cedulaEncargadoRef}>
                    <option selected value="V">
                      V
                    </option>
                    <option value="J">J</option>
                    <option value="E">E</option>
                  </Select>
                  <SearchInput />
                </div>
                <div className="col-3 m-0 mb-2 ml-auto p-0">
                  <Select label="Nacionalidad:" ref={nacionalidadEncargadoRef}>
                    <option selected value="V">
                      V
                    </option>
                    <option value="J">J</option>
                    <option value="E">E</option>
                  </Select>
                </div>
                <div className="col-4 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Fecha de Nacimiento:"
                    type="date"
                    ref={fechaNacEncargadoRef}
                  />
                </div>
                <div className="col-6 m-0 mb-2 p-0">
                  <Input label="Nombres:" ref={nombresEncargadoRef} />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pl-2">
                  <Input label="Apellidos:" ref={apellidosEncargadoRef} />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Dirección:"
                    style={{ height: 70 }}
                    ref={direccionEncargadoRef}
                  />
                </div>
                <div className="col-4 m-0 p-0">
                  <Input label="E-mail:" ref={emailEncargadoRef} />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="Teléfono:" ref={telefonoEncargadoRef} />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label="Celular:" ref={celularEncargadoRef} />
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Select label="Sexo:" ref={sexoEcargadoRef}>
                    <option selected value="M">
                      M
                    </option>
                    <option value="F">F</option>
                  </Select>
                </div>
              </fieldset>
            </article>
          </div>
          <div
            className="tab-pane fade"
            id="nav-otrosDatos"
            role="tabpanel"
            aria-labelledby="nav-otrosDatos-tab"
            tabindex="0"
          >
            <article className="col-12 m-0 p-0 d-flex flex-wrap align-items-start">
              <div className="col-6 m-0 p-0 pr-2">
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Actividad Principal:"
                    ref={actividadPrincipalRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Fecha de Inscripción:"
                    type="date"
                    ref={fechaInscripcionRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input label="% Retencion I.S.L.R:" ref={retencionISLRRef} />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Clasificacion I.S.L.R:"
                    style={{ height: 70 }}
                    ref={clasificacionISLRRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input label="Capital Pagado:" ref={capitalPagadoRef} />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input label="Capital Suscrito:" ref={capitalSuscritoRef} />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Select
                    label="Tipo de Contribuyente:"
                    ref={tipoContribuyenteRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Select label="Estatus del Proveedor:" ref={estatusRef} />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox label="Exonerado de IVA:" ref={exoneradoRef} />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Fecha de Registro:"
                    type="date"
                    ref={fechaRegistroRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Oficina de Registro:"
                    style={{ height: 70 }}
                    ref={oficinaRegistroRef}
                  />
                </div>
              </div>
              <fieldset className="col-6 m-0 p-2 border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Copias de Recaudo
                </legend>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Registro Mercantil/Modificaciones"
                    id="registroMercantil"
                    ref={registroMercantilRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Balance Gral. Visado y Auditado"
                    id="balanceGeneral"
                    ref={balanceGeneralRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Servicio Nacional Contratista"
                    id="servicioNacional"
                    ref={servicioNacionalRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Cédula del Representante"
                    id="cedulaRepresentante"
                    ref={cedulaRepresentanteRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Constancia Sucnacoop"
                    id="constanciaSucnacoop"
                    ref={constanciaSucnacoopRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Planilla I.S.L.R Ultimo Ejercicion"
                    id="planillaISLR"
                    ref={planillaISLRRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="RIF Actualizado"
                    id="rifActualizado"
                    ref={rifActualizadoRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Solvencia I.V.S.S"
                    id="solbenciaIVSS"
                    ref={solvenciaIVSSRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Solvencia I.N.C.E.S"
                    id="solvenciaINCES"
                    ref={solvenciaINCESRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Solvencia Laboral"
                    id="solvenciaLaboral"
                    ref={solvenciaLaboralRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Checkbox
                    label="Solvencia Municipal"
                    id="solvenciaMunicipal"
                    ref={solvenciaMunicipalRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Ultima Actualización:"
                    ref={ultimaActualizacionRef}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="N° Licencia Actividad Económica:"
                    ref={licenciaRef}
                  />
                </div>
                <div className="col-12 m-0 p-0">
                  <Input
                    label="Código de Acitvidad Económica:"
                    ref={codigoAcitvidadRef}
                  />
                </div>
              </fieldset>
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-6 m-0 mb-2 p-0 pr-2">
                  <Input label="Protocolo:" ref={protocoloRef} />
                </div>
                <div className="col-6 m-0 mb-2 p-0">
                  <Input label="N° de Protocolo:" ref={numeroProtocoloRef} />
                </div>
                <div className="col-6 m-0 mb-2 p-0 pr-2">
                  <Input label="Folio:" ref={folioRef} />
                </div>
                <div className="col-6 m-0 p-0">
                  <Input label="Numero de Registro:" ref={numeroRegistroRef} />
                </div>
              </div>
            </article>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
